<template>
  <div class="bill-details"  ref="container">
    <div class="nav acea-row">
      <div class="item" :class="types == 0 ? 'on' : ''" @click="changeTypes(0)">
        全部
      </div>
      <div class="item" :class="types == 1 ? 'on' : ''" @click="changeTypes(1)">
        充值成功
      </div>
      <div class="item" :class="types == 2 ? 'on' : ''" @click="changeTypes(2)">
        未支付
      </div>
      <div class="item" :class="types == 3 ? 'on' : ''" @click="changeTypes(3)">
        已失效
      </div>
    </div>
    <div class="sign-record">
      <div class="list">
        <div class="item" v-for="(val, index) in list" :key="index">
          <div class="listn">
             <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1" >
                    状态：
                    <span v-if="val.paid == 1" style="color:#16ac57;font-size:.3rem;">{{ val.status_name }}</span>
                    <span v-if="val.paid == 0" style="color:#018079;font-size:.3rem;">
                        {{ val.status_name }}
                        <a href="javascript:;" @click="cancelRechargePay(index)" class="recharge font-color-red">取消支付</a>
                    </span>
                    <span v-if="val.paid == 2" style="color:#000;font-size:.3rem;">{{ val.status_name }}</span>
                </div>
              </div>

              <div style="width:100%;">
                <div class="name line1" style="width:100%;">
                    充值：<span v-if="val.account_money>0 && val.goods_area == 1">{{moneyType.account_money}}（{{ val.account_money }}）</span>
                    <span v-if="val.account_money>0 && val.goods_area == 2">{{moneyType.password_money}}（{{ val.account_money }}）</span>
                    <span v-if="val.safe_money>0" >{{moneyType.safe_money}}（{{ val.safe_money }}）</span>
                    <span v-if="val.train_money>0" >{{moneyType.train_money}}（{{ val.train_money }}）</span>
                </div>
              </div>
              <div>
                <div>下单时间：{{ val.add_time }}</div>
                  <div>支付时间：{{ val.pay_time }}</div>
              </div>
                 <div style="">
                      <div class="num"  v-if="val.paid == 1" style="color:#16ac57;font-size:.2rem;">
                          现金抵扣：{{ val.use_bonus_money }}
                          <br/>
                          支付费用：{{ val.price }}
                      </div>
                         <div class="num"  v-if="val.paid == 0" style="color:#018079;font-size:.2rem;">
                             现金抵扣：{{ val.use_bonus_money }}
                             <br/>
                             支付费用：{{ val.price }}
                         </div>
                         <div class="num"   v-if="val.paid == 2" style="color:#000;font-size:.2rem;">
                             现金抵扣：{{ val.use_bonus_money }}
                             <br/>
                             支付费用：{{ val.price }}
                         </div>
                 </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>

import { rechargeList,cancelRechargePay } from "@api/user";
import Loading from "@components/Loading";
export default {
  name: "RechargeList",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      types: "",
      where: {
        page: 1,
        limit: 5
      },
      list: [],
        moneyType:[],
      loaded: false,
      loading: false
    };
  },
  watch: {
    "$route.params.types": function(newVal) {
      let that = this;

      if (newVal != undefined) {
        that.types = newVal;
        that.list = [];
        that.moneyType = [];
        that.where.page = 1;
        that.loaded = false;
        that.loading = false;
        that.getIndex();
      }
    },
    types: function() {
      this.getIndex();
    }
  },
  mounted: function() {
    let that = this;
    that.types = that.$route.params.types;
    that.getIndex();
    that.$scroll(that.$refs.container, () => {
      !that.loading && that.getIndex();
    });
  },
  methods: {
      cancelRechargePay:function(index){
          let that = this,id = that.list[index].id;
          cancelRechargePay(
              {
                  'id': id
              }
          ).then(
              res => {
                  that.$dialog.toast({
                      mes: "操作成功!",
                      callback: () => {
                          that.list.splice(index, 1);
                          that.$set(that, "list", that.list);
                      }
                    })
              },
              err => {
                  that.$dialog.message(err.msg);
              }
          );
      },
    changeTypes: function(val) {

      if (val != this.types) {
        this.types = val;
        this.list = [];
        this.where.page = 1;
        this.loaded = false;
        this.loading = false;
      }
    },
    getIndex: function() {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;

        rechargeList(that.where, that.types).then(
        res => {
          that.loading = false;
          that.loaded = res.data.list.length < that.where.limit;
          that.where.page = that.where.page + 1;
        that.moneyType = res.data.moneyType;
          that.list.push.apply(that.list, res.data.list);

        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
<style>
    .recharge {
        font-size: 0.28rem;
        width: 1.5rem;
        height: 0.54rem;
        border-radius: 0.27rem;
        background-color: #018079;
        text-align: center;
        line-height: 0.54rem;
        color: #fff9f8 !important;
        padding:0.2rem;
    }
</style>
